<template>
  <div>
      <div class="banner agora-blue">

    </div>
  <div class="min-h-screen bg-gray-50 py-10 px-4">
    
    <div class="wrapper mx-auto bg-white shadow-lg rounded-lg overflow-hidden">
      
      
      
      

      <!-- Book Content -->
      <div class="grid grid-cols-1 lg:grid-cols-3 gap-8 p-8">
        
        <!-- Left Column: Cover Image -->
        <div class="flex justify-center items-start lg:col-span-1">
          <div class="w-full max-w-xs rounded-lg overflow-hidden shadow-md">
            <img
              :src="'/Images/b'+id+'.jpg'" 
              :alt="'Book '+id" 
              class="w-full h-auto object-cover"
            >
          </div>
        </div>

        <!-- Right Column: Details -->
        <div class="lg:col-span-2 flex flex-col justify-start space-y-6">
          <div>
            <h1 class="text-4xl font-bold text-gray-800 mb-2 leading-tight">
              {{ $t("books.b"+id+".title") }}
            </h1>
          </div>
          
          <div v-html="$t('books.b'+id+'.description')" class="text-gray-600 text-base leading-relaxed prose prose-sm max-w-none">
          </div>

          <div class="flex flex-wrap gap-4 pt-6 border-t border-gray-200">
            <a v-if="$t('books.b'+id+'.link') !== 'soon'"
              :href="$t('books.b'+id+'.link')" 
              target="_blank" 
              class="agora-blue hover:bg-purple-600 text-white font-bold py-3 px-6 rounded-lg shadow transition duration-200"
            >
              {{ $t("books.buyOnAmazon") }}
            </a>
                <div v-else class="agora-blue hover:bg-purple-600 text-white font-bold py-3 px-6 rounded-lg shadow transition duration-200">
                {{ $t("Soon") }}
                </div>
           <router-link 
  :to="{ name: 'home', params: { locale: $i18n.locale }, hash: '#Catalog' }" 
  class="text-gray-600 hover:text-gray-900 font-semibold py-3 px-6 transition duration-200 border border-gray-300 rounded-lg"
>
  {{ $t("books.backToCatalog") }}
</router-link>




          </div>
        </div>

      </div>
    </div>
  </div>
  </div>
</template>

<script>
export default {
  name: "BookDetails",
  data() {
    return {
      loading: true,
      id:0
    };
  },
  created() {
    
    const queryId = this.$route.params.id;
    this.id=queryId ;
    
    this.loading = false;
  }
};
</script>
